export default {
  common: {
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    back: 'Back',
    done: 'Done',
    reload: 'Reload',
    loading: 'Loading..',
    delete: 'Delete',
    add: 'Add',
    update: 'Update',
    ok: 'OK',
    errorPrefix: 'Error: {name}. {message}',
  },
  stop: {
    reason: {
      'out-of-stock': 'Out of stock',
      'too-busy': 'Too busy',
      'quality-issue': 'Quality issue',
      'wait-and-retry': 'Slow now, ask later',
      other: 'Other',
    },
  },
  update: {
    newVersionHeader: 'New version available',
    newVersionMessage: 'Update to new version?',
    yesReload: 'Yes, reload',
    noIgnore: 'No, ignore',
    toastMessage: 'New version available: v{current} → v{latest}',
    toastMessageFallback: 'A new version is available',
    statusUpToDate: 'Up to date',
    statusChecking: 'Checking…',
    statusAvailable: 'v{latest} available',
    checkNow: 'Check for updates',
    appVersion: 'App version',
  },
  auth: {
    addUser: 'Add User',
    versionHeader: 'Version',
    versionHashHeader: 'Version hash',
  },
  shift: {
    startShift: 'Start Shift',
    goToAccount: 'Go to Account',
  },
  kitchen: {
    title: 'Kitchen',
    table: 'Table',
    noTable: 'No table',
    loadingBoard: 'Loading board..',
    noOrders: 'No orders yet',
    collapsedOrders:
      'None ready | {n} more item ready | {n} more items ready | {n} more items ready',
    collapseOrders: 'Collapse',
    tabs: {
      active: 'Active',
      done: 'History',
      stopList: 'Stop list',
    },
    stopList: {
      activeEmpty: 'Nothing on stop',
      activeHeader: 'On stop ({count})',
      allItemsHeader: 'All menu items',
      searchPlaceholder: 'Search menu items',
      noMatches: 'No matches',
      pickReason: 'Reason',
      pickUntil: 'Until',
      pickScope: 'Scope',
      scopeWholeItem: 'Whole item',
      pickerHeader: 'Put on stop',
      commentLabel: 'Comment (optional)',
      commentPlaceholder: 'Add a hint for the wait staff',
      save: 'Put on stop',
      untilShift: 'End of shift',
      until1h: '1 hour',
      until3h: '3 hours',
      untilManual: 'Until cleared',
      untilMinutes: 'until in {count} min',
      untilHours: 'until in {count} h',
      clearConfirmTitle: 'Clear stop?',
      clearConfirmMessage: 'Take {name} off the stop list?',
      clearConfirmYes: 'Yes, clear',
      noItemsForMenu: 'No items in this menu match your role',
      noAccessibleMenus: 'No menus you can manage',
      sidebarTitle: 'On stop now',
      sidebarEmptyHeading: 'Stop list is clean',
      sidebarEmptyHint: 'Tap a dish on the right to put it on stop',
    },
  },
  quickOrder: {
    title: 'Quick Order',
    order: 'Order',
    clear: 'Clear',
    sidebarPlaceholder: 'Add items on the left',
  },
  order: {
    order: 'Order',
    itemOnStop: 'On stop',
    orderUnknown: 'Unknown order',
    checkout: 'Checkout',
    sendToWork: 'Send to work',
    batch: 'BATCH',
    draftBatch: 'DRAFT BATCH',
    addOrderToTable: 'Add order to table',
    cancelOrder: 'Cancel Order',
    assignToMe: 'Assign to me',
    reassignTo: 'Reassign to…',
    reassignPickHeader: 'Assign this table to',
    reassignNoStaffOnShift: 'No staff on shift right now',
    items: 'no items | {count} item | {count} items',
    table: 'Table',
    tableUnknown: 'Unknown table',
    total: 'Total',
    payment: 'Payment',
    promotions: 'Promotions',
    payCash: 'Pay in Cash',
    payCard: 'Pay with Card',
    startBatch: 'Start Batch',
    contentPlaceholder: 'Tap "Start Batch" in the sidebar to add menu-items.',
    receiptPrinted: 'Receipt is printed...',
    finalise: 'Finalise',
    noOrderPlaceholder: 'No order yet',
    createOrder: 'Create Order',
    addMenuItem: 'Add Menu item',
    sidebarPlaceholder: 'Add items on the right',
    newOrder: 'New Order',
    noItemsInCategory: 'No items in category',
    noMenusFound: 'No menus found',
    added: 'Added',
    commentAlert: {
      header: 'Enter your comment',
      placeholder: 'Enter text here',
    },
    cancelConfirm: {
      header: 'Cancelling order.',
      message: 'Please confirm to cancel the order.',
      yes: 'Yes',
      no: 'No',
    },
    moveItems: {
      enter: 'Move items',
      selectTarget: 'Select a table',
      submit: 'Move here',
      submitTo: 'Move {from} → {to}',
      cancel: 'Cancel',
      mustLeaveOne: 'Leave at least 1 item',
      errorNotApplied: 'Move not applied',
      errorReverted: 'Move reverted',
      errorBroken: 'Move broken — items in both orders: {ids}',
    },
  },
  transaction: {
    paid: 'Paid',
    reversed: 'Reversed',
    type: 'Type',
    total: 'Total',
    items: 'Items',
    label: 'Transaction #{number}',
    reverse: 'Reverse',
    printFiscal: 'Print Fiscal Check',
    printPreCheck: 'Print Pre-Check',
    loading: 'Loading transactions..',
    newTransaction: 'New Transaction',
    creating: 'Creating transaction..',
    addCash: 'Add Cash',
    addCard: 'Add Card',
    finalise: 'Finalise',
    printerNotConfigured: 'Printer is not configured or connected',
    printerError: 'Error response from printer: {response}',
    confirmPrint: {
      header: 'Print fiscal check?',
      message:
        'Please confirm if you would like to print fiscal check. This can not be undone.',
      print: 'Print',
    },
  },
  promotions: {
    sidebarTitle: 'Applied Promotions',
    contentTitle: 'Add Promotion',
    sidebarPlaceholder: 'Add promotions on the right',
    remove: 'Remove',
    done: 'Done',
    searchInputPlaceholder: 'Start typing',
    searchCancel: 'Cancel',
    searchPlaceholder: 'Start typing and search results will appear here.',
    matchingPromotions: 'Matching Promotions',
    apply: 'Apply',
    applied: 'Applied',
    scanVoucher: 'Scan voucher code',
    noSuggestions: 'No promotions suggested',
    noItemsFound: 'No items found.',
    searchResults: 'Search results',
  },
  inHouse: {
    title: 'In House',
    filterMap: 'Map',
    filterStatus: 'Status',
    filterWaiter: 'Waiter',
    mapMove: 'Move',
    mapMoveCancel: 'Cancel',
    mapMoveSelectTable: 'Select a table to move to',
    mapMoveTitle: 'Move order from table {from} to {to}',
    tables: 'no tables | {count} table | {count} tables',
    noMapCreated: 'No map created',
    statusWaitingTitle: 'Waiting',
    statusInProgressTitle: 'In Progress',
    statusIdleTitle: 'Idle',
    statusCheckedOutTitle: 'Checked Out',
  },
  stock: {
    title: 'Stock',
    filterStock: 'Stock',
    filterGoods: 'Goods',
    filterOrders: 'Orders',
    newOrder: 'New Order',
    noStockAvailable: 'No available stock',
    noStockOrders: 'No stock orders',
    noVendor: 'No vendor',
    statuses: {
      backlog: 'Backlog',
      progress: 'In progress',
      arrived: 'Arrived',
      complete: 'Complete',
    },
    orderModal: {
      title: 'Stock Order',
      noItemsYet: 'No items yet',
      tapToAdd: 'Tap an item in the catalogue to add it',
      tabProducts: 'Products',
      tabSupplies: 'Supplies',
      searchProductsPlaceholder: 'Search products...',
      searchSuppliesPlaceholder: 'Search supplies...',
      emptyCatalog: 'Nothing found',
      done: 'Done',
      setAmount: 'Set amount',
      clearItems: 'Clear items',
      deleteOrder: 'Delete Order',
    },
    createGoodsModal: {
      create: 'Create',
    },
  },
  tasks: {
    title: 'Tasks',
    sidebarTitle: 'Today',
    sidebarEmptyHeading: 'No tasks today',
    sidebarEmptyHint: 'Tasks assigned to you will show up here.',
    selectPrompt: 'Pick a task on the left.',
    noneAssigned: 'You have no active tasks assigned.',
    subtasksProgress: '{completed} / {total} subtasks',
    detail: {
      status: {
        completed: 'Completed',
        'in-progress': 'In progress',
        missed: 'Missed',
        pending: 'Pending',
      },
      subtasks: 'Subtasks',
      verification: 'Verification',
      reference: 'Reference photos',
      takePhoto: 'Take photo',
      addComment: 'Add comment',
      submitted: 'Submitted',
      markAsDone: 'Mark as done',
      undo: 'Mark as not done',
      commentPlaceholder: 'Add a comment…',
      uploadFailed: 'Upload failed: {message}',
      unknownError: 'unknown error',
    },
  },
  settings: {
    title: 'Settings',
    selectPrinter: 'Select printer',
    notSetUp: 'Not set up',
    debugPrinter: 'Debug Printer',
    fiscal: {
      cardTitle: 'Fiscal Settings',
      cardSubtitle: 'Fiscal',
      description: 'Settings related to fiscal printer.',
      selectedPrinter: 'Selected Printer',
      noPrintersFound: 'No printers found',
      devMode: 'Dev Mode',
      receiptPreview: 'Receipt Preview',
      openLog: 'Open Log',
      printerLog: 'Printer Log',
    },
    fiscalActions: {
      cardTitle: 'Fiscal Actions',
      cardSubtitle: 'Fiscal',
      description: 'Perform actions on the printer.',
      printDuplicate: 'Print Duplicate',
      xReport: 'X Report',
      zReport: 'Z Report',
      periodReport: 'Period Report',
    },
    periodReport: {
      title: 'Period report',
      description:
        'Turnover by tax group and VAT for the selected dates, printed on the fiscal printer.',
      from: 'From',
      to: 'To',
      mode: 'Report type',
      detailed: 'Detailed',
      brief: 'Brief',
      withPayments: 'Split by payment type',
      print: 'Print report',
      hint: 'Only days closed with a Z report appear in the report.',
    },
    station: {
      cardTitle: 'Station Settings',
      cardSubtitle: 'Station',
      description: 'Station settings.',
      waitersOrderBoard: 'Waiters Order Board',
      menuItemUnits: 'Menu Item Units Displayed',
      noUnitsSelected: 'No units selected',
      preferLocalServer: 'Prefer local server',
      resetServerPreference: 'Reset server preference',
    },
    push: {
      cardTitle: 'Push notifications',
      cardSubtitle: 'Reminders for tasks assigned to you',
      enableToggle: 'Enable on this device',
      sendTest: 'Send test notification',
      testDelivered: 'Delivered to {sent} of {total}',
      testFailed: 'Failed to send',
      notSupported: "This device doesn't support web push notifications.",
    },
  },
}
